import { OmniboxProvider } from "@/contexts/OmniboxContext.tsx";
import { type ReactNode, useEffect } from "react";
import { useSearchParams } from "wouter";
import { useTourManager } from "./hooks/useTourManager.tsx";
import { tourSteps } from "./tourSteps/tourSteps.tsx";

export const Nux = ({ children }: { children: ReactNode }) => {
  const [searchParams, _setSearchParams] = useSearchParams();
  const nux = searchParams.get("nux");

  const { startTour, renderPortal } = useTourManager({
    steps: tourSteps,
  });

  // // Start tour when nux param is present
  useEffect(() => {
    if (nux) {
      startTour();
    }
  }, [nux, startTour]);

  return (
    <OmniboxProvider>
      {children}
      {renderPortal()}
    </OmniboxProvider>
  );
};
